// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2U-lW","title":"AfterFrontImage_title__316eU"};